import { storage } from '@uhg-abyss/web/tools/storage';
import { getFeature } from '@sde/widgets-core/src/redux/tools/features';
import { config } from '@uhg-abyss/web/tools/config';

export const handleLogout = () => {
    storage.session.remove('selectedTab');
    const permissionsStorageKey = 'provider-permissions';
    storage.local.remove(permissionsStorageKey);
    storage.session.remove('session-expiry-time');
    window.location.href = `${
      getFeature('OHID_SESSION_REWORK')
        ? `${config('IDENTITY_API_URL_BREAKOUT')}/logout/v2`
        : `${config('IDENTITY_API_URL_BREAKOUT')}/logout`
    }`;
}
